import { Button } from "../../Button";
import { Text } from "../../Typography";

export const ModalDelete = ({ loading, item, onCancel, onConfirm }: any) => {
  const onClickConfirm = () => {
    onConfirm(item);
  };

  return (
    <div>
      <Text>Desea eliminar?</Text>
      <br />
      <Text>
        {item.collection.charAt(0).toUpperCase() + item.collection.slice(1)}:{" "}
        {item.name}
      </Text>

      <div className="actions">
        <Button disabled={loading} outlined onClick={onCancel}>
          Cancelar
        </Button>
        <Button loading={loading} red onClick={onClickConfirm}>
          Confirmar
        </Button>
      </div>
    </div>
  );
};
